import React, {useEffect, useState} from "react"
import {Container, Row, Col, Nav} from "react-bootstrap";
import NavComponent from "./NavComponent";
import {GetPage} from "../../services/pages.service";
import ReactHtmlParser from "react-html-parser";

const Shipping = () => {
    const [data, setData] = useState([])

    useEffect(() => {
        getPage()
    }, [])

    async function getPage() {
        await GetPage({slug: "shipping"}).then((result) => {
            if (result.status && result.data) {
                setData(result.data)
            }
        }).catch((error) => {
            console.log("error", error.message);
        })
    }

    return (
        <>
            <div className="faq-page">
                <div className="faq-container">
                    <div className="banner-img"></div>
                    <Container>
                        <Row className="justify-content-center py-5">
                            <Col xs={12} md={12} xl={3}>
                                <NavComponent/>
                            </Col>

                            <Col xs={12} md={12} lg={12} xl={9}>
                                <Row>
                                    <Col xs={12}>
                                        <div className="w-100 pb-4 py-xl-5 text-center">
                                            {/*<h1>Shipping</h1>*/}
                                            <h1>{data?.title || "Shipping"}</h1>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12}>
                                        <div className="ps-xl-5">
                                            <p className="mt-3">
                                                {ReactHtmlParser(data?.content) || "No Data Found"}
                                            </p>
                                            {/*<p>
                                                To return your product, you should mail your product to: physical address.
                                                <br /><br />
                                                You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.
                                                <br /><br />
                                                Depending on where you live, the time it may take for your exchanged product to reach you may vary.
                                                <br /><br />
                                                If you are returning more expensive items, you may consider using a trackable shipping service or purchasing shipping insurance. We don’t guarantee that we will receive your returned item.
                                            </p>*/}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default Shipping
